/**
 * @generated SignedSource<<4921a62dc6b14d832b71be6cf32a7e64>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentHeader_space$data = {
  readonly id: string | null;
  readonly theme: {
    readonly themeKey: string | null;
  } | null;
  readonly " $fragmentType": "ContentHeader_space";
};
export type ContentHeader_space$key = {
  readonly " $data"?: ContentHeader_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ContentHeader_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "54644388464a7491be5acf735f23aa0c";

export default node;
